
/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />
namespace TabAurous.Finance {
    @Serenity.Decorators.registerClass()
    export class ReceiptDetailsDialog extends _Ext.EditorDialogBase<ReceiptDetailsRow> {
        protected getFormKey() { return ReceiptDetailsForm.formKey; }
        protected getLocalTextPrefix() { return ReceiptDetailsRow.localTextPrefix; }
        protected getDeletePermission() { return ReceiptDetailsRow.deletePermission; }
        protected getInsertPermission() { return ReceiptDetailsRow.insertPermission; }
        protected getUpdatePermission() { return ReceiptDetailsRow.updatePermission; }
        public static lock: boolean;
        public static ledgerId: number;
        public static amount: number;
        protected form = new ReceiptDetailsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        public exchangerate;
        constructor() {
            super();
            q.setTextRightAlign(this.form.Amount);
            q.setTextRightAlign(this.form.ExchangeRateId);
            q.showAndDisableField(this.form.Mode);
            this.form.LedgerId.changeSelect2(e => {
                if (this.form.LedgerId.value == "1001") {
                    this.form.Mode.value = "Cash";
                    q.hideField(this.form.ChequeDate);
                    q.hideField(this.form.ChequeNo);
                    q.hideField(this.form.RefNo);
                    q.HideCategoryLable(this.element);
                }
                else {
                    this.form.Mode.value = "Cheque";
                    q.ShowCategoryLable(this.element);
                    q.showAndSetRequiredField(this.form.ChequeDate);
                    q.showAndSetRequiredField(this.form.ChequeNo);
                    q.showAndSetRequiredField(this.form.RefNo);
                }
            });
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            var ledgerId = parseInt((this.parentEditor.parentDialog as ReceiptDialog).form.LedgerId.value);
            var currencyid = parseInt((this.parentEditor.parentDialog as ReceiptDialog).form.CurrencyId.value);
            if (currencyid == undefined) {
                Q.alert('Please Select Currency');
                this.dialogClose();
                return;
            } else {
                this.form.ExchangeRateId.value = (this.parentEditor.parentDialog as ReceiptDialog).form.ExchangeRate.value;
                q.showAndDisableField(this.form.ExchangeRateId);
            }
            if (ledgerId == undefined || ledgerId == 0) {
                Q.alert('Please Select Party');
                this.dialogClose();
                return;
            }
            var knockoff = (this.parentEditor.parentDialog as ReceiptDialog).form.KnockOffTotal.value == null ? 0 : (this.parentEditor.parentDialog as ReceiptDialog).form.KnockOffTotal.value;
            var checkknockoff = knockoff > 0 ? true : false;
            if (checkknockoff) {

                q.HideDialogToolbar(this.element);
                q.showAndDisableField(this.form.Mode);
                q.showAndDisableField(this.form.ChequeDate);
                q.showAndDisableField(this.form.ChequeNo);
                q.showAndDisableField(this.form.Amount);
                q.showAndDisableField(this.form.LedgerId);
                if (this.form.LedgerId.value == "1001") {
                    this.form.Mode.value = "Cash";
                    q.hideField(this.form.ChequeDate);
                    q.hideField(this.form.ChequeNo);
                    q.hideField(this.form.RefNo);
                    q.HideCategoryLable(this.element);
                }
                else {
                    this.form.Mode.value = "Cheque";
                    q.ShowCategoryLable(this.element);
                    q.showAndSetRequiredField(this.form.ChequeDate);
                    q.showAndSetRequiredField(this.form.ChequeNo);
                    q.showAndSetRequiredField(this.form.RefNo);
                }
            }
        }
        
    }
}